module.exports = __webpack_public_path__ + "static/media/duvidas.c59cdd39.svg";